import { NewsListingItem } from '@/components/NewsListing';
import type { NewsItem } from '@/components/NewsListing/redux/interface';
import { Row } from '@simplywallst/ui-core';
import { NewsItemWrapper } from './styled';

export interface NewsListingProps {
  data: NewsItem[];
  handleNavigationToURL: (url: string, index: number) => void;
}

const NewsListing = ({ data, handleNavigationToURL }: NewsListingProps) => (
  <Row>
    {data.length > 0 ? (
      data.slice(0, 3).map((n, i) => (
        <NewsItemWrapper col={12} colMd={4} key={`NewsListingItem-${i}`}>
          <NewsListingItem
            url={n.url}
            index={i}
            headline={n.headline}
            providerName={n.providerName}
            dateDiffFriendly={n.dateDiffFriendly}
            handleNavigationToURL={handleNavigationToURL}
          />
        </NewsItemWrapper>
      ))
    ) : (
      <p>No news available</p>
    )}
  </Row>
);

export default NewsListing;
